@for (grade of getExistingGrades(); track grade) {
      <div class="flex-row gap-2 flex-wrap">
        @for (schoolClass of schoolClasses; track schoolClass) {
          @if (schoolClass.grade == grade) {
            <div class="width100 my-1">
              <p-card [class]="'sm-card ' + schoolClass.getGuiClass()">
                <a [style.width]="'100%'"
                  routerLink="{{baseUrl}}/{{schoolClass.id}}/{{isHalfYear ? 1 : 0}}"
                routerLinkActive="active">{{schoolClass.getDisplayName()}}</a>
              </p-card>
            </div>
          }
        }
        <br>
        </div>
      }